/**
 * App entry point:
 * - init global modules, settings
 * - set-up shell/router
 * - boot app
 * - showing first activity
 * - and hide loading screen when done
 */

/** Global dependencies **/
import './init/polyfills';
import './init/knockout';
import './init/bootstrap';
import * as shell from './init/shell';
import boot from './init/boot';

boot(async () => {
    // Start shell
    shell.create({
        get(routeName) {
            switch (routeName) {
                case 'monitor': return import('./activities/monitor/index.js');
                default: Promise.reject(`The activity ${routeName} don't exist`);
            }
        }
    }, {
        indexName: 'monitor',
    }).run();
});
